module.exports = {"220503001":"桃园街道","220503002":"东通化街道","220503100":"鸭园镇","220503101":"铁厂镇","220503102":"五道江镇","220503200":"二道江乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/220503.json
// module id = 729
// module chunks = 0